export default __webpack_public_path__ + "static/media/vino.0478c61d.jpg";